import React from "react"
import {NavLink} from "react-router-dom"

const Navigation = props => (
  <div className="sidebar">
    <div className="header">
      <NavLink exact to="/">
        <h1>SABAG Shelf</h1>
      </NavLink>
    </div>
    {props.children}
  </div>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigations/Navigation.js